// Per-provider supported animation clip lengths (seconds). grok/pixverse
// accept any 1-15 (ImageAnimatorModal exposes 5/10/15); gemini & gemini-fast
// (Veo 3.1) only accept 4/6/8. The fal.ai image-to-video providers each have
// their own accepted set (mirrors the middleware provider services' snap/clamp
// ranges): kling 5/10/15, ltx 6/8/10, seedance 4-12 (we expose 5/8/12), hailuo
// is fixed-length (no duration param) so it has NO custom durations — only the
// panel's "Auto" chip shows and the bulk picker omits durationSec.
// Single source of truth for ImageAnimatorModal's Duration dropdown and the
// bulk-animate duration picker (pickAnimationDuration) so both read the same list.
const GROK_PIXVERSE_DURATIONS = [5, 10, 15];
const GEMINI_DURATIONS = [4, 6, 8];
const KLING_DURATIONS = [5, 10, 15];
const LTX_DURATIONS = [6, 8, 10];
const SEEDANCE_DURATIONS = [5, 8, 12];
const HAILUO_DURATIONS = []; // fixed-length output, no duration param

export function supportedDurationsForProvider(provider) {
  switch (provider) {
    case "grok":
    case "pixverse":
      return GROK_PIXVERSE_DURATIONS;
    case "kling":
      return KLING_DURATIONS;
    case "ltx":
      return LTX_DURATIONS;
    case "seedance":
      return SEEDANCE_DURATIONS;
    case "hailuo":
      return HAILUO_DURATIONS;
    default:
      return GEMINI_DURATIONS;
  }
}

// The provider's supported value numerically closest to the element's
// on-screen window (ties -> the larger value). Unlike pickAnimationDuration
// (bulk-animate's picker, which floors short windows at 5s), this has no
// floor — callers only use it when a real window is known.
export function nearestAllowedDuration(provider, windowSec) {
  const options = supportedDurationsForProvider(provider);
  return options.reduce((best, candidate) => {
    const bestDist = Math.abs(best - windowSec);
    const candidateDist = Math.abs(candidate - windowSec);
    if (candidateDist < bestDist) return candidate;
    if (candidateDist === bestDist && candidate > best) return candidate;
    return best;
  }, options[0]);
}

// ImageAnimatorModal's Süre dropdown DEFAULT: preselect the nearest allowed
// duration to the element's scene window — every provider, both loop modes.
// null → keep "Otomatik" selected (no computable window, or a fixed-length
// provider like hailuo that has no duration param).
export function defaultDurationForWindow(provider, windowSec) {
  if (typeof windowSec !== "number" || !Number.isFinite(windowSec)) return null;
  if (supportedDurationsForProvider(provider).length === 0) return null;
  return nearestAllowedDuration(provider, windowSec);
}
